import PopupAbstract from 'pk/components/Popup/PopupAbstract'
import { markRaw } from 'vue'
import PopupIndustry from './PopupIndustry.vue'

export default class PopupIndustryService extends PopupAbstract {
  public name = 'PopupIndustryService'
  protected component = markRaw(PopupIndustry)
}
